import { IconFont } from '@/components/IconFont'
import { Menu } from 'antd'
import { memo, useMemo } from 'react'
import { useNavigate } from 'react-router'
import { Outlet, useMatch } from 'react-router-dom'
import styles from './index.module.less'

export default memo(function OrganizationSetting() {
  const navigate = useNavigate()
  const match = useMatch('/:organizationName/setting/:key/*')
  const activeKey = useMemo(() => match?.params.key || '', [match])

  return (
    <div className={styles.container}>
      <div className={styles.sider}>
        <Menu
          className={'setting-menu'}
          mode='inline'
          selectedKeys={[activeKey]}
          onSelect={({ key }) => {
            navigate(key)
          }}
        >
          <Menu.Item key='general' icon={<IconFont type={'icon-dashboard'} />}>
            General
          </Menu.Item>

          <Menu.Divider className={'my-2'} />

          <Menu.ItemGroup title='Organization policy' key='policy'>
            <Menu.Item key='terms' icon={<IconFont type={'icon-fill'} />}>
              Terms
            </Menu.Item>
          </Menu.ItemGroup>

        </Menu>
      </div>
      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  )
})
